import { useDocumentVisibility } from 'ahooks';
import { Modal } from 'antd';
import { useEffect, useRef } from 'react';
import { LOCALE } from '@/utils';

const CONFIG_MAPS = {
  zh_CN: { title: '当前商城语言版本已切换！', okText: '刷新页面' },
  en_US: { title: 'Site lang changed!', okText: 'Reload' },
};

type Key = keyof typeof CONFIG_MAPS;

export const useLocaleChange = () => {
  const previousRef = useRef<string | null>();
  const documentVisibility = useDocumentVisibility();

  useEffect(() => {
    if (documentVisibility === 'hidden') {
      previousRef.current = LOCALE.getLocale();
    } else if (documentVisibility === 'visible') {
      if (previousRef.current) {
        const locale = LOCALE.getLocale();
        if (previousRef.current !== locale) {
          const { title, okText } =
            CONFIG_MAPS[previousRef.current as Key] || {};
          Modal.warning({
            title,
            okText,
            onOk: () => window.location.replace('/'),
          });
        }
      }
    }
  }, [documentVisibility]);
};
